// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2199":"3b53517f","3389":"3b53517f","4383":"3b53517f"}[chunkId] + ".chunk.css";
};